<section class="login-page">
    <div class="container-fluid">
        <div class="row">

            <!--- Welcome image  --->
            <div class="col-md-6 col-lg-6 col-xl-6 col-xxl-5">
                <div class="login-image">
                    <img src="assets/images/logo-white.png" alt="logo">
                    <div class="login-content">
                        <h2>Welcome to QCAM</h2>
                        <p>QMigrator is an AI based tool for migrating on-prem or cloud databases such as Oracle, SQL
                            Server, DB2 to Open-source databases like PostgreSQL, MySQL or MariaDB in any cloud. Below
                            are the top features of QMigrator to help you migrate your databases quickly.</p>
                    </div>
                    <div class="login-footer">
                        <ul>
                            <li><a href="https://qmigrator.ai" target="_blank">Marketplace</a></li>
                            <li><a href="#">License</a></li>
                            <li><a href="#">Terms of Use</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-lg-6 col-xl-6 col-xxl-7">
                <div class="login-form reset-form">
                    <div class="login-from-content" [hidden]="otpSent">
                        <h2>Reset QMigrator Password</h2>
                        <!--- Login Form  --->
                        <form class="form qmig-Form" [formGroup]="loginForm" (ngSubmit)="Otpsent(loginForm.value)">
                            <div class="form-group">
                                <i class="mdi mdi-at"></i>
                                <input type="text" class="form-control" placeholder="user@example.com"
                                    formControlName="mail" />
                                <span class="mdi mdi-close" (click)="resetUser()"></span>
                                @if ( f.mail.touched && f.mail.invalid) {
                                <p class="text-start text-danger mt-1">
                                    @if (f.mail.errors.required) { Email is required }
                                    @if (f.mail.errors.email) { Please enter valid email. }
                                </p>
                                }
                            </div>
                            <div class="form-group">
                                <i class="mdi mdi-account"></i>
                                <input type="text" class="form-control" placeholder="User Name"
                                    formControlName="userName" />
                                <span class="mdi mdi-close" (click)="resetPassword()"></span>
                                @if ( f.userName.touched && f.userName.invalid) {
                                <p class="text-start text-danger mt-1">
                                    @if (f.userName.errors.required) { userName is required }
                                </p>
                                }
                            </div>
                            <div>
                                <button class="btn btn-sign w-100 " [disabled]="loginForm.invalid"> Reset Password
                                    @if(spinner){<app-spinner-white />} </button>
                            </div>
                            <p class="mt-3"><a href="javascript:void(0)" routerLink="/login"> Back to Login ? </a> </p>
                        </form>
                    </div>
                    <div class="otpValidation" [hidden]="!otpSent || otpVerified">
                        <form>
                            <input id='input1' type='text' maxLength="1" (keyup)="onKeyUp($event, 0)" />
                            <input id='input2' type='text' maxLength="1" (keyup)="onKeyUp($event, 1)" />
                            <input id='input3' type='text' maxLength="1" (keyup)="onKeyUp($event, 2)" />
                            <input id='input4' type='text' maxLength="1" (keyup)="onKeyUp($event, 3)" />
                            <div>
                                <button class="btn btn-sign w-100 mt-3" (click)="submitOTP()"> Verify OTP
                                    @if(otpSpin){<app-spinner-white />} </button>
                            </div>
                        </form>
                    </div>
                    <div class="login-from-content" [hidden]="!otpVerified">
                        <h2>Change QMigrator Password</h2>
                        <p>email:{{this.email}}</p>
                        <!--- Login Form  --->
                        <form class="form qmig-Form" [formGroup]="resetPasswordform"
                            (ngSubmit)="Resetpassword(resetPasswordform.value)">

                            <div class="form-group">
                                <i class="mdi mdi-lock-outline"></i>
                                <input class="form-control" [type]="!text_checks ? 'NewPassword' : 'password'"
                                    id="NewPassword" formControlName="NewPassword" placeholder="New Password"
                                    (input)="checkPasswordValidation()" (focus)="onPasswordFocus()">
                                <span [ngClass]="text_checks ? 'mdi mdi-eye-off' : 'mdi mdi-eye'" class="eye_design"
                                    (click)="sendEyes()"></span>
                                @if ( g.NewPassword.touched && g.NewPassword.invalid) {
                                <p class="text-start text-danger mt-1">
                                    @if (g.NewPassword.errors.required) {New Password is Required }
                                    @if (g.NewPassword.errors.minlength) {New Password must be at least 8 characters. }
                                </p>
                                }

                            </div>
                            <div class="form-group">
                                <i class="mdi mdi-lock-check-outline"></i>
                                <input class="form-control" type="password" id="ConfirmPassword"
                                    formControlName="ConfirmPassword" placeholder="Confirm Password">
                                @if ( g.ConfirmPassword.touched && g.ConfirmPassword.invalid) {
                                <p class="text-start text-danger mt-1">
                                    @if (g.ConfirmPassword.errors.required) {Confirm Password is Required }
                                    @if (g.ConfirmPassword.errors.confirmedValidator) {New Password and Confirm Password
                                    must be match. }
                                </p>
                                }
                            </div>
                            <div>
                                <button class="btn btn-sign w-100 " [disabled]="resetPasswordform.invalid"> Change
                                    Password @if(spinner){<app-spinner-white />} </button>
                            </div>
                         

                        </form>
                           <!-- Password Validation Points -->
                           @if(isPasswordFocused){
                            <ul class="password-validation-list">
                                <li
                                    [ngClass]="{ 'valid': passwordValidation.uppercase, 'invalid': !passwordValidation.uppercase  }">
                                    @if(passwordValidation.uppercase){
                                    <span class="validation-icon"> <i class="mdi mdi-check"></i></span>
                                    At least one uppercase letter
                                    }@else{
                                    <span class="validation-icon"> <i class="mdi mdi-check"></i></span>
                                    At least one uppercase letter
                                    }
                                </li>
                                <li
                                    [ngClass]="{ 'valid': passwordValidation.lowercase, 'invalid': !passwordValidation.lowercase  }">
                                    @if(passwordValidation.lowercase){
                                    <span class="validation-icon"> <i class="mdi mdi-check"></i></span>
                                    At least one lowercase letter
                                    }@else{
                                    <span class="validation-icon"> <i class="mdi mdi-check"></i></span>
                                    At least one lowercase letter
                                    }
                                </li>
                                <li
                                    [ngClass]="{ 'valid': passwordValidation.number, 'invalid': !passwordValidation.number  }">
                                    @if(passwordValidation.number){
                                    <span class="validation-icon"> <i class="mdi mdi-check"></i></span>
                                    At least one number
                                    }@else{
                                    <span class="validation-icon"> <i class="mdi mdi-check"></i></span>
                                    At least one number
                                    }
                                </li>
                                <li
                                    [ngClass]="{ 'valid': passwordValidation.specialChar, 'invalid': !passwordValidation.specialChar  }">
                                    @if(passwordValidation.specialChar){
                                    <span class="validation-icon"> <i class="mdi mdi-check"></i></span>
                                    At least one special character
                                    }@else{
                                    <span class="validation-icon"> <i class="mdi mdi-check"></i></span>
                                    At least one special character
                                    }
                                </li>
                            </ul>
                            }
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>